var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isPostMethod
      ? _c("div", [
          _c(
            "button",
            {
              ref: "launchActionHandlerButton",
              staticClass: "btn init-cart",
              class: _vm.cssClasses,
              attrs: {
                type: "button",
                "aria-label": _vm.ariaLabel,
                disabled: _vm.disabled,
                "data-timer": _vm.dataTimer,
                "data-oevent-category": _vm.tmsDtoCategory,
                "data-oevent-action": _vm.tmsDtoAction,
                "data-oevent-label": _vm.tmsDtoLabel,
              },
              on: {
                click: function ($event) {
                  return _vm.launchActionHandler($event)
                },
              },
            },
            [
              _c("span", { class: { "d-lg-none": _vm.withDesktopButton } }, [
                _vm._v(_vm._s(_vm.buttonLabel)),
              ]),
              _vm._v(" "),
              _vm.withDesktopButton
                ? _c("span", { staticClass: "d-none d-lg-inline-block" }, [
                    _vm._v(_vm._s(_vm.desktopButtonLabel)),
                  ])
                : _vm._e(),
            ]
          ),
        ])
      : _vm.isGetMethod
      ? _c("div", [
          _c(
            "a",
            {
              staticClass: "btn",
              class: _vm.cssClasses + (_vm.disabled ? " disabled" : ""),
              attrs: {
                "aria-disabled": _vm.disabled,
                href: _vm.actionUrl,
                "aria-label": _vm.ariaLabel,
                "data-oevent-category": _vm.tmsDtoCategory,
                "data-oevent-action": _vm.tmsDtoAction,
                "data-oevent-label": _vm.tmsDtoLabel,
              },
            },
            [
              _c("span", { class: { "d-lg-none": _vm.withDesktopButton } }, [
                _vm._v(_vm._s(_vm.buttonLabel)),
              ]),
              _vm._v(" "),
              _vm.withDesktopButton
                ? _c("span", { staticClass: "d-none d-lg-inline-block" }, [
                    _vm._v(_vm._s(_vm.desktopButtonLabel)),
                  ])
                : _vm._e(),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }